export enum ChannelType {
    LINKEDIN = 'LINKEDIN',
    EMAIL = 'EMAIL',
    NOTE = 'NOTE',
}
